<div [@routerTransition]>
    <div class="kt-subheader kt-grid__item mb-5">
        <div class="kt-subheader__main">
            <h3 class="kt-subheader__title cursor-pointer">
                <span translation="Axilla.Webshop.FieldAgent.Promotions" source="Axilla"></span>
            </h3>
        </div>
        <div class="kt-subheader__toolbar">
            <div class="kt-subheader__wrapper d-flex align-items-center">
                <ng-container *ngIf="isAllowNavigateToOrderConfirmation; else confirmOrder">
                    <button class="btn btn-primary"
                            (click)="verifyPromotions()">
                        <span translation="Axilla.BasketOverview.ConfirmOrder" source="Axilla"></span>
                    </button>
                </ng-container>
                <ng-template #confirmOrder>
                    <button class="btn btn-primary"
                            [disabled]="isDisabled"
                            (click)="verifyPromotions()">
                            {{ "Axilla.Webshop.FieldAgent.VerifyPromotions" | localize }}
                    </button>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="kt-content distribution">
        <div class="kt-portlet">
            <div class="kt-portlet__body">
                <ng-container *ngIf="totalItemAmount && orderAmount && promotionValue && promotionValueInEuro">
                    <div class="d-flex align-items-center p-justify-center gap-2 promotion-limits" [ngClass]="{'exceeded': isPromotionLimitExceeded}">
                        <span>Current Order:</span>
                        <span>
                        {{orderAmount | currency:getCurrency():'symbol-narrow':'.2-2'}}
                    </span>
                        <ng-container *ngIf="promotionValue > 0">
                        <span>
                            x
                        </span>
                            <span>
                            {{promotionValue}} %
                        </span>
                        </ng-container>
                        <span>
                        =>
                    </span>
                        <span>
                        {{promotionValueInEuro | currency:getCurrency():'symbol-narrow':'.2-2'}}
                    </span>
                        <span>
                        <>
                    </span>
                        <span>
                        {{totalItemAmount | currency:getCurrency():'symbol-narrow':'.2-2'}}
                    </span>
                    </div>
                </ng-container>

                <app-combine-view
                    [hideSorting]="true"
                    [isSelectingArticles]="true"
                    (onQuickAction)="onQuickAction($event)"
                    (loadData)="getLocalWarehouse($event)"></app-combine-view>
            </div>
        </div>
    </div>
</div>
